import * as _ from 'gleam:prelude'

export function read() {
  try {
    if (typeof window !== 'undefined' && window.Cypress !== undefined)
      return _.Result$Ok('cypress')
    const mode = import.meta.env.MODE
    if (mode === undefined) return _.Result$Error()
    return _.Result$Ok(mode)
  } catch (error) {
    return _.Result$Error()
  }
}
